import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navigation.css';

const Navigation = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const _token = localStorage.getItem('token');
  const isLoggedIn = isAuthenticated || (!!_token && _token.split('.').length === 3 && !!localStorage.getItem('user'));
  const location = useLocation();
  
  // Check if current path matches the provided path
  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };
  
  return (
    <nav className="main-navigation">
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/">
            <h1>Salon Pricing Calculator</h1>
          </Link>
        </div>
        
        <div className="nav-links">
          {isLoggedIn ? (
            <>
              <Link to="/dashboard" className={isActive('/dashboard') ? 'active' : ''}>
                Dashboard
              </Link>
              
              <div className="dropdown">
                <button className={`dropdown-button ${isActive('/calculator') ? 'active' : ''}`}>
                  Calculator <i className="fas fa-chevron-down"></i>
                </button>
                <div className="dropdown-content">
                  <Link to="/calculator/services">Services</Link>
                  <Link to="/calculator/products">Products</Link>
                  <Link to="/calculator/overheads">Overheads</Link>
                  <Link to="/calculator/staff">Staff</Link>
                  <Link to="/calculator/price-calculator">Advanced Calculator</Link>
                  <Link to="/calculator/history">History</Link>
                  <Link to="/calculator/settings">Settings</Link>
                </div>
              </div>
              
              <Link to="/business-settings" className={isActive('/business-settings') ? 'active' : ''}>
                Business Settings
              </Link>
              
              <Link to="/history" className={isActive('/history') ? 'active' : ''}>
                Calculation History
              </Link>
              
              {/* Admin Dashboard link - only shown for users with admin role */}
              {user && user.role === 'admin' && (
                <Link to="/admin" className={isActive('/admin') ? 'active' : ''}>
                  <i className="fas fa-user-shield"></i> Admin Dashboard
                </Link>
              )}
              
              <button className="btn-logout" onClick={logout}>
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className={isActive('/login') ? 'active' : ''}>
                Login
              </Link>
              <Link to="/register" className={isActive('/register') ? 'active' : ''}>
                Register
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;